module.exports = __webpack_public_path__ + "9516cf53dff3c8e8d1069f378bb96b15.jpg";